import { loadSession } from "./session";

export const formatCurrencyBRL = (value: number) =>
  value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

export const formatCurrencyBRL4 = (value: number) =>
  value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatNumberBR = (value: number) =>
  new Intl.NumberFormat('pt-BR').format(value);

export const formatPercentBR = (value: number) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2,
  }).format(value / 100);

export const formatUSDT = (value:number) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  }).format(value);
};

export const formatDateGetToday = (end?:boolean) : string => {
  const today = new Date();
  let formattedDate = today.toISOString().split('T')[0];
  if (end) formattedDate = formattedDate + "T23:59:59";

  return formattedDate;
}

export const formatGetTodayDate = () : string => {
      const d = new Date();
      return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
}

export const getStorageData = () : any => {
  return loadSession() ?? {};
}

export const formatShortId = (id: string, size:number) => {
  if (!id || id.length <= 10) return id ?? '';
  return `${id.slice(0, size)}...${id.slice(-size)}`;
};